export default __webpack_public_path__ + "static/media/ES-Internship Brochure.85212c66.pdf";